import batchDetails from './batchDetails';

export const batchDetailsActions = batchDetails.actions;
export const batchDetailsReducer = batchDetails.reducer;
